import { api } from "@api/api";
import { masks } from "@core/utils/masks";
import { Subscription } from "@modules/subscriptions/types";
import { SubscriptionFormValues } from "@modules/subscriptions/validations";

export async function editSubscriptionService(
  id: string,
  data: Partial<SubscriptionFormValues>
): Promise<Subscription> {
  if (data?.cpf) {
    data.cpf = masks.unmask(data.cpf);
  }

  const { data: subscription } = await api.patch<Subscription>(
    `v1/subscription_admin/${id}/`,
    data
  );

  return subscription;
}
